import { useState, useMemo, useCallback, useEffect, forwardRef } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  Grid,
  TextField,
  Stack,
  Tabs,
  Tab,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ReactQuill from "react-quill";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import {
  cleanQuillHtml,
  generateSectionHtml,
} from "../components/commonFunctions";
import { defaultemailTemplates } from "../components/staticData";
import axios from "axios";
import { ArrowBack } from "@mui/icons-material";
import { useRef } from "react";
const EmailTemplateEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isEditorInitialized = useRef(false);
  const navigateData = location.state;
  const [activeTab, setActiveTab] = useState("body");
  const [prvTemplate, setPrvTemplate] = useState({});
  const [template, setTemplate] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [toast, setToast] = useState({ success: false, error: false, msg: "" });
  const [editorState, setEditorState] = useState(
    EditorState.createEmpty(template?.body?.html)
  );


  useEffect(() => {
    if (!template?.body?.html) return;
    if (isEditorInitialized.current) return;

    const blocksFromHtml = htmlToDraft(template.body.html);
    const contentState = ContentState.createFromBlockArray(
      blocksFromHtml.contentBlocks,
      blocksFromHtml.entityMap
    );

    setEditorState(EditorState.createWithContent(contentState));
    isEditorInitialized.current = true;
  }, [template?.body?.html]);
  console.log("template", template?.body?.html);
  // console.log("prvTemplate", prvTemplate);
  const fullEmailHtml = useMemo(() => {
    return generateSectionHtml(template?.body);
  }, [template]);

  const fetchTemplate = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/gettemplate/${id}`
      );

      // Corrected data access - adjust based on your actual API response structure
      const apiTemplate = response?.data?.data;

      if (apiTemplate) {
        setTemplate(apiTemplate);
        setPrvTemplate(apiTemplate);
      } else {
        setTemplate(defaultemailTemplates[id]);
        setPrvTemplate(defaultemailTemplates[id]);
      }
    } catch (err) {
      console.error("Error fetching templates:", err);
    }
  };
  useEffect(() => {
    if (navigateData) {
      setTemplate(navigateData);
      setPrvTemplate(navigateData);
    } else {
      fetchTemplate();
    }
  }, [id]);
  
  const loadTemplate = (tpl) => {
    isEditorInitialized.current = false;
    setTemplate(tpl);
  };
  
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSaveEditor = async (template, html) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/save-template`,
        {
          type: id,
          template,
          html,
        }
      );
      if (response?.status === 200) {
        setPrvTemplate(template);
        setToast({ error: false, success: true, msg: "Template Saved!" });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleBodyChange = (field, value) => {
    if (field == "html") {
      setEditorState(value);
      const html = draftToHtml(convertToRaw(value.getCurrentContent()));
      setTemplate((prevState) => {
        const newState = {
          ...prevState,
          body: {
            ...(prevState.body || {}),
            html: html,
          },
        };
        return newState;
      });
    } else {
      setTemplate((prevState) => {
        const newState = {
          ...prevState,
          body: {
            ...(prevState.body || {}),
            [field]: value,
          },
        };
        return newState;
      });
    }
  };

  const handleSubjectChange = (e) => {
    setTemplate((prev) => ({
      ...prev,
      subject: e.target.value,
    }));
  };
  const handleNameChange = (e) => {
    setTemplate((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleReset = () => {
    loadTemplate(defaultemailTemplates?.[id]);
    // handleSaveEditor(
    //   defaultemailTemplates?.[id],
    //   cleanQuillHtml(fullEmailHtml)
    // );
  };
  const wrapperStyle = {
  };
  
  const editorStyle = {
    backgroundColor: "#ffffff",
    fontSize: "14px",       // 👈 fixes huge text
    lineHeight: "1",

  };
  
  const toolbarStyle = {
    backgroundColor: "#E5E7EB",
    fontSize: "14px",
  };
  
  const renderTabContent = () => {
    switch (activeTab) {
      case "subject":
        return (
          <TextField
            required
            fullWidth
            hiddenLabel
            variant="filled"
            value={template?.subject}
            onChange={handleSubjectChange}
            autoComplete="off"
            placeholder="Enter email Subject.."
            error={!template?.subject}
          />
        );
      case "body":
        return (
          <Stack>
            <Stack direction={"row"} spacing={2} sx={{ maxWidth: 250 }}>
              <TextField
                variant="standard"
                size="small"
                label={
                  <Typography fontWeight={"500"} fontSize={"16px"}>
                    Text color
                  </Typography>
                }
                type="color"
                fullWidth
                slotProps={{
                  input: {
                    disableUnderline: true,
                  },
                }}
                value={template?.body?.textColor}
                onChange={(e) => {
                  handleBodyChange("textColor", e.target.value);
                }}
              />

              <TextField
                variant="standard"
                size="small"
                label={
                  <Typography fontWeight={"500"} fontSize={"16px"}>
                    Background color
                  </Typography>
                }
                type="color"
                fullWidth
                slotProps={{
                  input: {
                    disableUnderline: true,
                  },
                }}
                value={template?.body?.bgColor}
                onChange={(e) => handleBodyChange("bgColor", e.target.value)}
              />
            </Stack>

            {false && (
              <ReactQuill
                theme="snow"
                placeholder="Type your body content here..."
                value={template?.body?.html}
                onChange={(value) => {
                  handleBodyChange("html", value);
                }}
                style={{
                  height: "min-content",
                  padding: "20px 0px",
                }}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, 4, 5, 6, true] }],
                    [{ font: [] }],
                    [{ color: [] }, { background: [] }],
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    [
                      { list: "ordered" },
                      { list: "bullet" },
                      { indent: "-1" },
                      { indent: "+1" },
                    ],
                    [{ align: [] }],
                    ["link", "code-block"],
                    // [{ direction: "rtl" }],
                    [{ script: "sub" }, { script: "super" }],

                    ["clean"],
                  ],
                }}
              />
            )}

            {1 && (
              <>
                <Editor
                  // ref={isEditorInitialized}
                  wrapperClassName="wrapper-class"
                  editorClassName="editor-class"
                  toolbarClassName="toolbar-class"
                  editorState={editorState}
                  onEditorStateChange={(value) =>
                    handleBodyChange("html", value)
                  }
                  wrapperStyle={wrapperStyle}
                  editorStyle={editorStyle}
                  toolbarStyle={toolbarStyle}
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "fontSize",
                      "fontFamily",
                      "list",
                      "textAlign",
                      "colorPicker",
                      "link",
                      "embedded",
                      "emoji",
                      "image",
                      "remove",
                      "history",
                    ],
                    inline: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                      options: [
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough",
                        "monospace",
                        "superscript",
                        "subscript",
                      ],
                      // bold: { icon: bold, className: undefined },
                      // italic: { icon: italic, className: undefined },
                      // underline: { icon: underline, className: undefined },
                      // strikethrough: {
                      //   icon: strikethrough,
                      //   className: undefined,
                      // },
                      // monospace: { icon: monospace, className: undefined },
                      // superscript: { icon: superscript, className: undefined },
                      // subscript: { icon: subscript, className: undefined },
                    },
                    blockType: {
                      inDropdown: true,
                      options: [
                        "Normal",
                        "H1",
                        "H2",
                        "H3",
                        "H4",
                        "H5",
                        "H6",
                        "Blockquote",
                        "Code",
                      ],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                    fontSize: {
                      // icon: fontSize,
                      options: [
                        8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72,
                        96,
                      ],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                    fontFamily: {
                      options: [
                        "Arial",
                        "Georgia",
                        "Impact",
                        "Tahoma",
                        "Times New Roman",
                        "Verdana",
                      ],
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                    },
                    list: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                      options: ["unordered", "ordered", "indent", "outdent"],
                      // unordered: { icon: unordered, className: undefined },
                      // ordered: { icon: ordered, className: undefined },
                      // indent: { icon: indent, className: undefined },
                      // outdent: { icon: outdent, className: undefined },
                    },
                    textAlign: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                      options: ["left", "center", "right", "justify"],
                      // left: { icon: left, className: undefined },
                      // center: { icon: center, className: undefined },
                      // right: { icon: right, className: undefined },
                      // justify: { icon: justify, className: undefined },
                    },
                    colorPicker: {
                      // icon: color,
                      className: undefined,
                      component: undefined,
                      popupClassName: undefined,
                      colors: [
                        "rgb(97,189,109)",
                        "rgb(26,188,156)",
                        "rgb(84,172,210)",
                        "rgb(44,130,201)",
                        "rgb(147,101,184)",
                        "rgb(71,85,119)",
                        "rgb(204,204,204)",
                        "rgb(65,168,95)",
                        "rgb(0,168,133)",
                        "rgb(61,142,185)",
                        "rgb(41,105,176)",
                        "rgb(85,57,130)",
                        "rgb(40,50,78)",
                        "rgb(0,0,0)",
                        "rgb(247,218,100)",
                        "rgb(251,160,38)",
                        "rgb(235,107,86)",
                        "rgb(226,80,65)",
                        "rgb(163,143,132)",
                        "rgb(239,239,239)",
                        "rgb(255,255,255)",
                        "rgb(250,197,28)",
                        "rgb(243,121,52)",
                        "rgb(209,72,65)",
                        "rgb(184,49,47)",
                        "rgb(124,112,107)",
                        "rgb(209,213,216)",
                      ],
                    },
                    link: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      popupClassName: undefined,
                      dropdownClassName: undefined,
                      showOpenOptionOnHover: true,
                      defaultTargetOption: "_self",
                      options: ["link", "unlink"],
                      // link: { icon: link, className: undefined },
                      // unlink: { icon: unlink, className: undefined },
                      linkCallback: undefined,
                    },
                    emoji: {
                      // icon: emoji,
                      className: undefined,
                      component: undefined,
                      popupClassName: undefined,
                      emojis: [
                        "😊",
                        "🙂",
                        "😀",
                        "😁",
                        "😉",
                        "😄",
                        "😌",
                        "🤗",
                        "😍",
                        "👍",
                        "👌",
                        "🙌",
                        "👏",
                        "🙏",
                        "✨",
                        "⭐",
                        "🌟",
                        "🔥",
                        "🎉",
                        "🎊",
                        "🎁",
                        "💡",
                        "📌",
                        "📣",
                        "📢",
                        "📩",
                        "✉️",
                        "📬",
                        "⏰",
                        "📅",
                        "🚀",
                        "🔔",
                        "✅",
                        "✔️",
                        "💯",
                        "💙",
                        "❤️",
                      ],
                    },
                    embedded: {
                      // icon: embedded,
                      className: undefined,
                      component: undefined,
                      popupClassName: undefined,
                      embedCallback: undefined,
                      defaultSize: {
                        height: "auto",
                        width: "auto",
                      },
                    },
                    image: {
                      // icon: image,
                      className: undefined,
                      component: undefined,
                      popupClassName: undefined,
                      urlEnabled: true,
                      uploadEnabled: true,
                      alignmentEnabled: true,
                      uploadCallback: undefined,
                      previewImage: false,
                      inputAccept:
                        "image/gif,image/jpeg,image/jpg,image/png,image/svg",
                      alt: { present: false, mandatory: false },
                      defaultSize: {
                        height: "auto",
                        width: "auto",
                      },
                    },
                    remove: {
                      // icon: eraser,
                      className: undefined,
                      component: undefined,
                    },
                    history: {
                      inDropdown: false,
                      className: undefined,
                      component: undefined,
                      dropdownClassName: undefined,
                      options: ["undo", "redo"],
                      // undo: { icon: undo, className: undefined },
                      // redo: { icon: redo, className: undefined },
                    },
                  }}
                />
              </>
            )}
          </Stack>
        );
      default:
        return (
          <Typography>Select a block to configure its settings.</Typography>
        );
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", p: 3 }}>
      <Stack spacing={3}>
        <Stack
          direction={{ sm: "column", md: "row" }}
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          {/* Left side — Back Button */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Button
              variant="string"
              startIcon={<ArrowBack />}
              onClick={() => {
                if (JSON.stringify(prvTemplate) !== JSON.stringify(template)) {
                  handleOpenDialog();
                } else {
                  navigate("/emailtemplates");
                }
              }}
            >
              Back
            </Button>
            <TextField
              hiddenLabel
              id="standard-basic"
              required
              variant="outlined"
              size="small"
              fullWidth
              value={template?.name}
              onChange={handleNameChange}
              error={!template?.name}
            />
          </Stack>

          {/* Right side — Reset & Save Buttons */}
          <Stack direction="row" spacing={2}>
            {template?.type !== "custom" && (
              <Button
                className="button"
                variant="outlined"
                disableElevation
                onClick={handleReset}
                sx={{
                  textTransform: "unset",
                }}
              >
                Reset to Default
              </Button>
            )}
            <Button
              variant="contained"
              className="button"
              disableElevation
              disabled={
                JSON.stringify(prvTemplate) === JSON.stringify(template)
              }
              sx={{
                textTransform: "unset",
              }}
              onClick={() => {
                if (!template?.name) {
                  setToast({
                    error: true,
                    msg: "Template name is required.",
                  });
                } else if (!template?.subject) {
                  setToast({
                    error: true,
                    msg: "Subject is required.",
                  });
                } else if (!template?.body?.html) {
                  setToast({
                    error: true,
                    msg: "Email body is required.",
                  });
                } else {
                  handleSaveEditor(template, cleanQuillHtml(fullEmailHtml));
                }
              }}
            >
              Save Template
            </Button>
          </Stack>
        </Stack>

        <Grid container spacing={3}>
          <Grid className="editor" item size={7}>
            <Card
              sx={{
                borderRadius: "14px",
                overflow: "hidden",
                background: "#f8f8f8",
                border: "1px solid #EEEEEE",
                boxShadow: "none",
              }}
            >
              <Stack>
                <Tabs
                  value={activeTab}
                  onChange={(e, newValue) => setActiveTab(newValue)}
                  variant="scrollable"
                  scrollButtons="auto"
                  className="tabs-outer"
                >
                  <Tab className="tab-item" label="Body" value="body" />
                  <Tab className="tab-item" label="Subject" value="subject" />
                </Tabs>

                <Box sx={{ p: 3, backgroundColor: "#ffffff" }}>
                  {renderTabContent()}
                </Box>
              </Stack>
            </Card>
          </Grid>

          <Grid className="editor" item size={5}>
            <Card
              sx={{
                borderRadius: "14px",
                background: "#f8f8f8",
                border: "1px solid #EEEEEE",
                boxShadow: "none",
              }}
            >
              <Stack spacing={0} sx={{ height: "100%" }}>
                <Typography
                  className="email-heading"
                  variant="subtitle1"
                  sx={{
                    fontWeight: "500",
                    px: 2,
                    py: 1.3,
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  subject : {template?.subject}
                </Typography>
                <Box sx={{ p: 2, backgroundColor: "#ffffff" }}>
                  <PreviewPanel html={cleanQuillHtml(fullEmailHtml)} />
                </Box>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>

      <Snackbar
        open={toast.success}
        autoHideDuration={800}
        onClose={() => setToast({ ...toast, success: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="success">{toast.msg}</Alert>
      </Snackbar>

      <Snackbar
        open={toast.error}
        autoHideDuration={1200}
        onClose={() => setToast({ ...toast, error: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="error">{toast.msg}</Alert>
      </Snackbar>
      <Dialog
        key="goback-modal"
        open={openDialog}
        keepMounted
        onClose={handleCloseDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Leave Editor?</DialogTitle>

        <DialogContent>
          <DialogContentText>
            You have unsaved changes. Leaving this page will discard them.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={handleCloseDialog}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={() => {
              handleCloseDialog();
              navigate("/emailtemplates");
            }}
          >
            Leave
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const PreviewPanel = ({ html }) => {
  return <div className="preview" dangerouslySetInnerHTML={{ __html: html }} />;
};
export default EmailTemplateEditor;
